import { useMemo, memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import MainSelect from '@UI/MainSelect';
import { useDeps } from '@Contexts/DI';
import styles from './Sizes.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { SelectItemData } from '@divlab/divanui';
import type { Parameter } from '@Pages/PageProduct/typings';

export interface SizesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  parameter: Parameter;
}

const Sizes: FC<SizesProps> = (props) => {
  const { className, parameter, ...restProps } = props;
  const { analytics } = useDeps();

  const sizesVariants: SelectItemData[] = useMemo(() => {
    if (!parameter.variants) {
      return [
        {
          id: parameter.groupId.toString(),
          title: parameter.name,
          name: parameter.values.map((item) => item.value.match(/\d+/)).join(' x '),
        },
      ];
    }

    return parameter.variants.map((variant) => ({
      id: variant.productId.toString(),
      title: `${variant.name}${variant.unit ? variant.unit.name : ''}`,
      name: `${variant.name}${variant.unit ? variant.unit.name : ''}`,
      href: variant.url,
      selected: !!variant.selected,
    }));
  }, [parameter]);

  const handleChangeSelected = useCallback(
    (e: MouseEvent, items: SelectItemData[]) => {
      if (items[0]?.selected) return;

      analytics.dispatchEvent('sizes.changeSelected');
    },
    [analytics],
  );

  return (
    <div {...restProps} className={cn(styles.sizes, className)}>
      <div className={styles.selectWrapper}>
        <MainSelect
          title={parameter.name}
          items={sizesVariants}
          wide
          bordered={false}
          onChangeSelected={handleChangeSelected}
        />
      </div>
    </div>
  );
};

export default memo(Sizes);
